import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import classes from "./FiltersBar.module.css"

interface Props {
  orderByExpanded: boolean
  onFiltersClick: () => void
  onOrderByClick: () => void
}

const FiltersBar = ({ onFiltersClick, onOrderByClick }: Props) => {
  return (
    <div className={classes.root}>
      <div className={classes.filter}>
        <CustomButton
          variant="text"
          className={classes.control}
          onClick={onFiltersClick}
          invariantCase
        >
          Filtra
        </CustomButton>
      </div>
      <div className={classes.orderBy}>
        <CustomButton
          variant="text"
          className={classes.control}
          onClick={onOrderByClick}
          invariantCase
        >
          Ordina per
        </CustomButton>
      </div>
    </div>
  )
}

export default FiltersBar
